import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

/**
 * Collapsed-by-default chart panel — data tables stay primary.
 */
export function ReportTrendPanel({
  title = "Trend (optional)",
  children,
  className,
  defaultOpen = false,
}) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? "trend" : undefined}
      className={cn(
        "mb-3 rounded-xl border border-[#F0E0D4] bg-white overflow-hidden",
        className,
      )}
      data-testid="report-trend-panel"
    >
      <AccordionItem value="trend" className="border-0">
        <AccordionTrigger className="px-3 py-2.5 text-[12.5px] font-semibold text-brand-brown/70 hover:no-underline hover:bg-[#FFF8F3]">
          {title}
        </AccordionTrigger>
        <AccordionContent className="px-3 pb-3 pt-0">
          <div className="h-[180px] w-full">{children}</div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
